import React from 'react';
import '../styles/Notif.css'
import StyledButton from './StyledButton';

const Notif = ({onClose})=>{
return(
    <div className='overlay'>

    <div className='notif'>
        <div className='content'>

       <p>
        Welcome ! 
        <br/>
            Please note that our website is not currently optimized for mobile devices. 
            <br/>
            We apologize for any inconvenience this may cause and are working to improve your browsing experience. 
            
            In the meantime, you can still access our website on a computer for the best viewing experience. 
       <br/>
        Thank you for your understanding, 
        and please check back soon for updates and additional features.
            </p>
        </div>
        
            
    <StyledButton onClick={onClose} size='small' type="danger" content="Close"/>
        
    </div>
    </div>
)
}
export default Notif;